import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import AppBody from "../components/AppBody";

const PlayRecording = () => {
  const state = useSelector((state) => state.trainingReducer);
  const navigate = useNavigate();

  useEffect(() => {}, []);
  const playRecording = () => {
    const recordingUrl = state.recording_url;
    if (recordingUrl) {
      var vi = document.getElementById("video");
      vi.src = recordingUrl;
      vi.load();
      vi.play();
    }
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <span
                  onClick={() => navigate(-1)}
                  className="d-inline-block mt-2"
                >
                  <i className="ti-arrow-left font-sm text-white"></i>
                </span>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Recording
                </h4>
              </div>
              <div className="card-body p-4 w-100 border-0 ">
                <div className="row cource-section">
                  <div className="col-lg-12 mb-3">
                    {state.recordingUrl ? (
                      <iframe
                        width="100%"
                        height="500"
                        src={state.recordingUrl && state.recordingUrl}
                      ></iframe>
                    ) : (
                      <h1>Recording Not Available</h1>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default PlayRecording;
